<template>
  <div>
    <el-dialog title="选择用户" :visible="dialogUser" top="70px" :close-on-click-modal="false" width="700px"
      @close="cancel">
      <div v-if="dialogUser">
        <el-form :inline="true" :model="formPromote" class="form-inline">
          <el-form-item label="用户账号">
            <el-input v-model="formPromote.account" placeholder="用户账号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="info" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" border style="width: 100%" v-loading="loading"
          :header-cell-style="{background:'#e9f1f5',}">
          <el-table-column prop="account" label="用户账号">
          </el-table-column>
          <el-table-column label="充值列表" width="300px">
            <template slot-scope="scope">
              <div class="recharge_box" v-for="(item,index) in scope.row.recharge_list" :key="index">
                <div class="name">{{ item.game_name }}</div>
                <div class="btn" @click="check(scope.row,item)">快捷充值</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="promote_account" label="渠道账号">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="check(scope.row)">选中用户</el-button>
            </template>
          </el-table-column>


        </el-table>
        <div class="page_box" v-show="total>10">
          <el-pagination background layout="prev, pager, next" :current-page="page" :total="total"
            @current-change="currentChange" :page-size="10">
          </el-pagination>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import {
    userLists,
  } from "@/api/home";
  export default {
    data() {
      return {
        formPromote: {
          account: ''
        },
        tableData: [],
        page: 1,
        total: 0,
        loading: false
      }
    },
    props: {
      dialogUser: {
        default: false
      },
      user: {
        default: true
      }
    },
    watch: {
      dialogUser(n, o) {
        if (n) {
          this.formPromote.account = ''
          this.page = 1
          this.getData()
        }
      }
    },
    created() {
      // this.getData()
    },
    methods: {
      cancel() {
        this.$emit('update:dialogUser', false)
      },
      currentChange(v) {
        this.page = v
        this.getData()
      },
      reset() {
        this.formPromote.account = ''
        this.page = 1
        this.getData()
      },
      getData() {
        let url = this.user ? '/bhcoin/promote_user_lists' : '/admin_function/all_users'
        this.loading = true
        userLists(url, {
          page: this.page,
          limit: 10,
          user_account: this.formPromote.account,
          admin_token: this.user ? '' : JSON.parse(localStorage.getItem('adminUser')).admin_token
        }).then(res => {
          if (res.code == 20001) {
            localStorage.removeItem('adminUser')
            this.$emit('update:dialogUser', false)
            this.$emit('openLogin')

          }
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          }
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      check(v, game) {
        this.$emit('checkUser', v, game)
      }
    }
  }
</script>

<style scoped lang="less">
  .page_box {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
  }

  .recharge_box {
    display: flex;
    align-items: center;
    margin-top: 5px;
    justify-content: space-between;

    &:first-child {
      margin-top: 0;
    }

    .name {
      margin-right: 5px;
    }

    .btn {
      background-color: #5adfab;
      color: white;
      padding: 2px 5px;
      border-radius: 4px;
      font-size: 15px;
      cursor: pointer;
      flex-shrink: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/component/search_user.vue